export default __webpack_public_path__ + "static/poster-product-healthcare-a58559866e9a93079397367135106b80.jpg";